import { FC, useContext, useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { download } from '../../api/File';
import { FileSystemContext } from '../FileSystem';
import apiUrl from '../../assets/apiUrl';
import file from '../../common/file';
import { getAccessToken } from '../Auth';

interface Props {
    file: file;
    openPropertiesViewer: () => void;
    onMove: (id: string) => void;
    onDelete: (file_uid: string) => void;
}

const MoreOptionsMenu: FC<Props> = ({
    file,
    openPropertiesViewer,
    onMove,
    onDelete,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event: any) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const { getSignedUrl } = useContext(FileSystemContext).useFilesMethods();
    const handleDownload = async () => {
        const { file_uid, filename, size } = file;
        download(
            await getSignedUrl(`${apiUrl}/file?file_uid=${file_uid}`),
            filename,
            parseInt(size),
            { auth: true, token: await getAccessToken() }
        );
        handleClose();
    };
    return (
        <>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => openPropertiesViewer()}>
                    <i className="fas fa-info-circle" />
                </MenuItem>
                <MenuItem onClick={handleDownload}>
                    <i
                        className="fas fa-download"
                        style={{ cursor: 'pointer' }}
                    />
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onMove(file.file_uid);
                        handleClose();
                    }}
                >
                    <i
                        className="fas fa-expand-arrows-alt"
                        style={{ cursor: 'pointer' }}
                    />
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onDelete(file.file_uid);
                        handleClose();
                    }}
                >
                    <i
                        className="fas fa-trash-alt"
                        style={{ cursor: 'pointer' }}
                    />
                </MenuItem>
            </Menu>
            <i
                className="fas fa-ellipsis-h"
                style={{ cursor: 'pointer' }}
                onClick={handleClick}
            />
        </>
    );
};

export default MoreOptionsMenu;
